module.exports = __webpack_public_path__ + "assets/media/1.760d022a.wav";